// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownFilter_dropdown__ApSQQ","icon_wrapper":"DropdownFilter_icon_wrapper__fvitj"};